import React, { Component } from 'react';

function paginatedDataSource(DataSourcedComponent, options) {
  class PaginatedDataSource extends Component {
    constructor(props) {
      super(props);
      this.state = {
        loading:    true,
        filters:    options.default_filter || {},
        sort_key:   options.sort_key || '',
        sort_state: options.sort_state || {},
        pagination: null,
        page: this.parseBrowserHash().page
      };

      this.fetchCSV            = this.fetchCSV.bind(this)
      this.fetchData           = this.fetchData.bind(this)
      this.handlePagination    = this.handlePagination.bind(this)
      this.buildSortableHeader = this.buildSortableHeader.bind(this)
      this.handleSort          = this.handleSort.bind(this)

      this.csvSubmit           = this.csvSubmit.bind(this)
      this.filterSubmit        = this.filterSubmit.bind(this)
      this.getFilters          = this.getFilters.bind(this)
      this.filterCallback      = this.filterCallback.bind(this)
    }

    parseBrowserHash() {
      return window.location.hash.split('&').map(function(e) {
        return e.replace('#', '').split('=')
      }).reduce(function(p, c) {
         p[c[0]] = c[1];
         return p;
      }, {})
    }

    componentDidMount() {
      this.fetchData();
    }

    handleSort(event) {
      const sort_key = $(event.currentTarget).data('field');

      const { sort_state } = this.state;
      sort_state[sort_key] = (sort_state[sort_key] === 'desc') ? 'asc' : 'desc'

      this.setState({ sort_key, sort_state }, () => {
        this.fetchData();
      });
    }

    filterCallback(value_object) {
      const { filters }  = this.state;
      Object.assign(filters, value_object)
      this.setState({ filters });
    }

    handlePagination(id) {
      this.setState({ page: id }, () => {
        this.fetchData();
      });
    }

    async csvSubmit() {
      this.setState({ loading: true });
      await this.fetchCSV();
      this.setState({ loading: false });
    }

    filterSubmit() {
      this.handlePagination(1)
    }

    getFilters() {
      const { filters } = this.state
      var filter_map = {}

      Object.keys(filters).forEach(function(key) {
        filters[key].path_func(filter_map, filters[key].value)
      });

      return filter_map
    }

    buildSortableHeader(title, key) {
      const { sort_state } = this.state;
      var type = sort_state[key]
      return (
        <div>
          {title} <span className={type ? `sort-#${type}` : ''}></span>
        </div>
      )
    }

    async fetchCSV() {
      var that = this;
      const { page, sort_key, sort_state, filters } = this.state
      const { archived, parseResponse } = this.props
      let param_filters;

      if (Object.keys(filters).length == 0) {
        param_filters = {empty: '',}
      } else {
        param_filters = filters
      }

      let params = jQuery.param({
        page:       page,
        sort:       sort_key,
        sort_order: sort_state[sort_key],
        filter:     param_filters,
        archived:   archived
      })

      // cannot download a file via Javascript because security,
      // so we open new tab instead of using fetch()
      window.open(`/admin/api/v1/${options.data_name}.csv?${params}`, '_blank')
    }

    fetchData() {
      var that = this;
      const { page, sort_key, sort_state, filters } = this.state
      const { archived, parseResponse } = this.props
      this.setState({loading: true});
      let param_filters;

      if (Object.keys(filters).length == 0) {
        param_filters = {empty: '',}
      } else {
        param_filters = filters
      }

      let params = jQuery.param({
          page:       page,
          sort:       sort_key,
          sort_order: sort_state[sort_key],
          filter:     param_filters,
          archived:   archived
        })

      fetch(`/admin/api/v1/${options.data_name}.json?${params}`, {
        credentials: 'same-origin',
      }).then((response) => { return response.json() })
        .then((data) => { that.setState({ loading: false }); parseResponse(data) })
        .catch((error) => { that.setState({ loading: false }); parseResponse({}) })
    }

    render() {
      const { data, pagination, sort_key, sort_state, loading, filters } = this.state;
      const { response_data } = this.props;
      return (<DataSourcedComponent data={response_data[options.data_name] || []}
                                    pagination={response_data.pagination || {}}
                                    paginationCallback={this.handlePagination}
                                    loading={loading}
                                    csvSubmit={this.csvSubmit}
                                    dataCallback={this.fetchData}
                                    sortCallback={this.handleSort}
                                    filters={filters}
                                    filterCallback={this.filterCallback}
                                    filterSubmit={this.filterSubmit}
                                    buildSortableHeader={this.buildSortableHeader}
                                    sort_field={sort_key}
                                    sort_order={sort_state[sort_key]}
                                    {...this.props} />);
    }
  }
  return PaginatedDataSource;
}

export default paginatedDataSource;
